import i18next from 'i18next';
import { DEFAULT_OWNER_GROUPS_I18N_PREFIX } from '@/lib/party-owner-dropdown.js';

/**
 * Grouped user / team / role options (same structure as asset owner in AssetBasicInfoForm).
 * @param {{ user?: unknown[], team?: unknown[], role?: unknown[] }} entities
 * @returns {Array<{ label: string, options: Array<{ value: unknown, label: string }> }>}
 */
export function buildGroupedOwnerSelectOptionsFromEntities(entities = {}) {
    const users = entities.user || [];
    const teams = entities.team || [];
    const roles = entities.role || [];
    const prefix = DEFAULT_OWNER_GROUPS_I18N_PREFIX;

    return [
        {
            label: i18next.t(`${prefix}.users`, { defaultValue: 'Users' }),
            options: users.map((u) => ({
                value: u._id || u.id,
                label: (u.firstName || u.lastName)
                    ? `${u.firstName || ''} ${u.lastName || ''}`.trim()
                    : (u.name || u.userName || u.email || '—'),
            })),
        },
        {
            label: i18next.t(`${prefix}.teams`, { defaultValue: 'Teams' }),
            options: teams.map((t) => ({
                value: t._id || t.id,
                label: t.name || t.teamName || t.label || '—',
            })),
        },
        {
            label: i18next.t(`${prefix}.roles`, { defaultValue: 'Roles' }),
            options: roles.map((r) => ({
                value: r._id || r.id,
                label: r.name || r.roleName || r.label || '—',
            })),
        },
    ];
}
